import { styled as r } from "styled-components";
import { Body as o } from "../../../../styles/typography/index.js";
import { Image as t } from "../../../../components/Image/index.js";
import { Theme as e } from "../../../../styles/themes/index.js";
const l = r.div`
  ${o};
  color: rgb(${e.colors.Alpha});
  & > * + * {
    margin-top: 0.75em;
  }
  position: relative;
`, n = r.p`
  ${o}
  color: rgb(${e.colors.Alpha});
  text-align: left;
  word-break: break-word;

  :empty:before {
    content: ' ';
    white-space: pre;
  }
`, d = r.ul`
  padding: 0 1rem;
  margin-left: 4px;
  list-style: circle;
`, s = r.ol`
  padding: 0 1rem;
  margin-left: 4px;
`;
r(t)`
  display: inline-block;
  width: auto;
  height: auto;
  max-width: 300px;
  max-height: 300px;
  border-radius: 12px;
  margin: 8px 0;
`;
export {
  s as OrderedList,
  n as Paragraph,
  l as Text,
  d as UnorderedList
};
